import omiPic from "@/public/images/artists/omi.png";
import { Artist } from "@/types/types";

export const omi = {
  id: "297",
  name: "Omi",
  image: omiPic,
  description: `Omi has a warm voice with a rich lower register and a gentle, smoky character.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fomi-preview.mp3",
  meta: {
    free: false,
    new: true,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Unprocessed", "RnB", "Airy"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Mid",
      },
      specific: {
        low: 48,
        high: 69,
      },
      sweetSpot: 60,
    },
  },
} as const satisfies Artist;
